import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerService from 'services/partnerService';

export type PartialPartnerRelationType = {
  hasPartner: string;
  techId: string;
  fullName: string;
  relationStatus: 'ACTIVE' | 'INACTIVE';
};

export const useFetchPartnerRelations = (techId: string) => {
  return useQuery<PartialPartnerRelationType[], AxiosError>({
    queryKey: ['getPartnerRelations', techId],
    queryFn: () => partnerService.getPartnerRelations(techId),
  });
};
